enum httpError {
  BadRequest = 400,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  InternalServerError = 500,
  NotImplemented = 501,
  BadGateway = 502,
  ServiceUnavailable = 503,
  GatewayTimeout = 504,
}

// API path
const httpAPI = process.env.REACT_APP_API_BASE_URL || "";

// 外部API path
enum httpAPIFromInternet {
  zipcloudForPostalCode = "https://zipcloud.ibsnet.co.jp/api/search",
  bankSearch = "https://apis.bankcode-jp.com/v3/banks",
}

const getHttpErrorMsg = (value: keyof typeof httpError) => {
  const errorKeys = Object.keys(httpError) as Array<keyof typeof httpError>;
  return errorKeys.find((key) => httpError[key] === httpError[value]);
};

const axiosSettingObj = {
  baseURL: httpAPI,
  timeout: 1200000,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/x-www-form-urlencoded",
  },
};

export {
  httpError,
  httpAPI,
  httpAPIFromInternet,
  getHttpErrorMsg,
  axiosSettingObj,
};
